export enum StavZadosti {
	POVOLEN = 'POVOLEN',
	NEOVEREN = 'NEOVEREN'
}
